import { NavLink } from 'react-router'
import { useTranslation } from 'react-i18next'
import type { MoreItem } from './navConfig'
import styles from './MoreSheet.module.css'

export function MoreSheet({
  items,
  open,
  onClose,
}: {
  items: MoreItem[]
  open: boolean
  onClose: () => void
}) {
  const { t } = useTranslation()
  return (
    <>
      <div
        className={`${styles.backdrop}${open ? ' ' + styles.backdropOpen : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`${styles.sheet}${open ? ' ' + styles.sheetOpen : ''}`}
        role="dialog"
        aria-label="More"
        aria-hidden={!open}
      >
        <div className={styles.grabber} />
        {items.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={styles.item}
              onClick={onClose}
            >
              <span className={styles.itemIcon}><Icon size={20} strokeWidth={1.75} /></span>
              {t(item.labelKey)}
            </NavLink>
          )
        })}
      </div>
    </>
  )
}
